import { apiFetchLanguages } from '../api/Argentia/endpoints/languages/languages.api'
import { LanguageModel } from '../api/Argentia/model/contracts'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../helpers/serviceResponseHelper'
import { mapDefaultLanguage, mapLanguagesResponse } from '../mappers/language.mapper'
import { ServiceResponse } from '../model/serviceResponse'

export const fetchLanguages = async (): Promise<ServiceResponse<LanguageModel[] | undefined>> => {
  return await apiFetchLanguages()
    .then(response => {
      return createSuccessServiceResponse(mapLanguagesResponse(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getDefaultLanguage = async (): Promise<LanguageModel | undefined> => {
  const languages = await fetchLanguages().then(response => {
    if (response.success) {
      return response.data
    } else {
      return undefined
    }
  })

  if (languages && languages?.length > 0) {
    const defaultLanguage = languages ? mapDefaultLanguage(languages) : undefined

    return {
      id: defaultLanguage ? defaultLanguage.id : languages[0].id,
      code: defaultLanguage ? defaultLanguage.code : languages[0].code,
      description: defaultLanguage ? defaultLanguage.description : languages[0].description,
      lgDefault: true
    } as LanguageModel
  } else {
    return undefined
  }
}
